import React, { ImgHTMLAttributes } from "react";
import logo from "../../assets/img/logo.svg.svg";

function Logo(props: ImgHTMLAttributes<HTMLImageElement>) {
	return <img src={logo} alt="SPATTRO Logo" {...props} />;
}

export default Logo;
